module.exports = __webpack_public_path__ + "img/pantone 1.a05f2316.png";